export const OFFER = 'offer';
